import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/flynn/code/web/sports/react-ncaa-data/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-ncaa-data"
    }}>{`react-ncaa-data`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Put live (or old) NCAA data in your website!`}</p>
    </blockquote>
    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-ncaa-data"
      }}><img alt="NPM" src="https://img.shields.io/npm/v/react-ncaa-data.svg" /></a>{` `}<a parentName="p" {...{
        "href": "https://standardjs.com"
      }}><img alt="JavaScript Style Guide" src="https://img.shields.io/badge/code_style-standard-brightgreen.svg" /></a></p>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install --save react-ncaa-data
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`First you need to configure a proxy. I like to use express, so here is an example on how to set that up. This allows the NCAA react component to properly reroute fetch's to the NCAA casablanca server.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`NOTE:`}</strong>{` this NCAA react component library defaults to '/ncaa_api' as shown below. If you use a different proxy api name....please make sure to set it accordingly.`}</p>
    </blockquote>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const express = require('express');

const targetUrl = 'https://data.ncaa/com/';

app.use( '/ncaa_api',        // this is the 'proxy_api' setting
         createProxyMiddleware({
           target: targetUrl,
           changeOrigin: true,
           pathRewrite: {
             '^/ncaa_api/': '/'
           }
         })
);

`}</code></pre>
    <p>{`Once you have your proxy configured, you can go ahead and import the NCAA context to use the data whereever you need to in your website.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React, { Component } from 'react'

import { useNCAA } from 'react-ncaa-data'

class Example extends Component {
  const { 
  render() {
    return <MyComponent />
  }
}
`}</code></pre>
    <h2 {...{
      "id": "license"
    }}>{`License`}</h2>
    <p>{`MIT © `}<a parentName="p" {...{
        "href": "https://github.com/flynneva"
      }}>{`flynneva`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      